var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pizarra"},[_c('div',{staticClass:"headerPizarra"},[_vm._m(0),_c('marcaEmpresarial',{attrs:{"data":_vm.data}})],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"containerPizarra"},[_c('h1',[_vm._v("Novedades")]),_c('h2',[_vm._v("Próximamente más información")])])
}]

export { render, staticRenderFns }